import Data from "../types/Data";
import Group from "../types/Group";
import { getHardcodedGroups } from "./getHardcodedGroups";

export default function getAllGroupsById(data: Data): Record<number, Group> {
  return { ...getHardcodedGroups(data), ...data.Group };
}
